const footer = () => (
  <div className="py-7 px-2 bg-[#044248] text-white text-lg text-center">
    Copyright © 2022 All Rights Reserved by Metaverse Media Group
  </div>
);

export default footer;
